export default __webpack_public_path__ + "static/IN-9008HD-vs-IN-5907HD_day-1cc873f703fc46857377b070c4bf586b.webp";